module.exports = __webpack_public_path__ + "img/guardian_buff_cursedchalice.357c6cf8.png";